import React from 'react';

import { type ThirdPartyProductsResponse, type ProviderResults } from '../../types';
import { type DataProvider } from './create-data-provider';
import { createAppSwitcherBffThirdPartyProductsProvider } from './app-switcher-bff-third-party-products-provider';

type RealProvider = DataProvider<ThirdPartyProductsResponse>;
const {
	fetchMethod: fetchAppSwitcherBffThirdPartyProducts,
	ProviderComponent: DefaultBffThirdPartyProductsDataProvider,
} = createAppSwitcherBffThirdPartyProductsProvider() as RealProvider;

interface Props {
	children: (thirdPartyProducts: ProviderResults['thirdPartyProducts']) => React.ReactNode;
	cloudId?: string;
	product?: string;
}

export const ThirdPartyProductsProvider = ({
	cloudId,
	children,
	product,
}: Props): React.JSX.Element => (
	<DefaultBffThirdPartyProductsDataProvider cloudId={cloudId} product={product}>
		{children}
	</DefaultBffThirdPartyProductsDataProvider>
);

export const prefetchThirdPartyProducts = fetchAppSwitcherBffThirdPartyProducts;
export const resetThirdPartyProducts = () => fetchAppSwitcherBffThirdPartyProducts.reset();
